/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddCountryFormDto } from '../models/AddCountryFormDto';
import type { AddLanguagesForm } from '../models/AddLanguagesForm';
import type { EntityModelResponseContainerCountryDto } from '../models/EntityModelResponseContainerCountryDto';
import type { PagedModelEntityModelCountryDto } from '../models/PagedModelEntityModelCountryDto';
import type { PagedResourcesAssemblerCountryDto } from '../models/PagedResourcesAssemblerCountryDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CountryControllerService {
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static addLanguages({
        requestBody,
    }: {
        requestBody: AddLanguagesForm,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/system/add_language_data',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PagedModelEntityModelCountryDto OK
     * @throws ApiError
     */
    public static list({
        assembler,
        page,
        size = 500,
        sort,
    }: {
        assembler: PagedResourcesAssemblerCountryDto,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelCountryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/countries',
            query: {
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerCountryDto OK
     * @throws ApiError
     */
    public static create({
        requestBody,
    }: {
        requestBody: AddCountryFormDto,
    }): CancelablePromise<EntityModelResponseContainerCountryDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/system/countries',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns EntityModelResponseContainerCountryDto OK
     * @throws ApiError
     */
    public static delete({
        countryId,
    }: {
        countryId: string,
    }): CancelablePromise<EntityModelResponseContainerCountryDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/system/countries/{countryId}',
            path: {
                'countryId': countryId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerCountryDto OK
     * @throws ApiError
     */
    public static read({
        countryId,
    }: {
        countryId: string,
    }): CancelablePromise<EntityModelResponseContainerCountryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/countries/{countryId}',
            path: {
                'countryId': countryId,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerCountryDto OK
     * @throws ApiError
     */
    public static update({
        countryId,
        requestBody,
    }: {
        countryId: string,
        requestBody: AddCountryFormDto,
    }): CancelablePromise<EntityModelResponseContainerCountryDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/system/countries/{countryId}',
            path: {
                'countryId': countryId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public static getLanguages(): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/country_languages',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static deleteLanguage({
        languageCode,
        messageKey,
    }: {
        languageCode: string,
        messageKey: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/system/delete_language/{languageCode}/keys/{messageKey}',
            path: {
                'languageCode': languageCode,
                'messageKey': messageKey,
            },
        });
    }
}
